import { useState, useEffect } from "react";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { addSubCategory, getSubCategory, updateSubCategory } from ".";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Autocomplete, TextField } from "@mui/material";
import { getCategories } from "../video";
import { AdminPageLayout, AdminSectionCard } from "../../components/admin/AdminPageLayout";
import { AdminAction, AdminFormFooter } from "../../components/admin";
import { resolveMediaUrl } from "../../utils/mediaUrl";

function getApiErrorMessage(error, fallback) {
  return (
    error.response?.data?.message ||
    error.response?.data?.data?.message ||
    error.message ||
    fallback
  );
}

export default function AddSubCategory() {
  const navigate = useNavigate();
  const location = useLocation();
  const [ID, setId] = useState(null);
  const [parent, setParent] = useState(null);
  const [categoryId, setCategoryId] = useState(1);
  const [data, setData] = useState(null);
  const [catId, setcatId] = useState(1);
  const [categoryData, setCategoryData] = useState([]);
  const [file, setFile] = useState(null);
  const [name, setName] = useState(null);
  const [hindi, setHindi] = useState(null);
  const [gujarati, setGujarati] = useState(null);
  const [kannada, setKannada] = useState(null);
  const [marathi, setMarathi] = useState(null);
  const [odia, setOdia] = useState(null);
  const [malayalam, setMalayalam] = useState(null);
  const [tamil, setTamil] = useState(null);
  const [telgu, setTelugu] = useState(null);
  const [bangla, setBangla] = useState(null);
  const [punjabi, setPunjabi] = useState(null);
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(
    "/placeholder-image.jpg"
  );

  const fetchData = async () => {
    try {
      const response = await getSubCategory(ID);
      const responseData = response.data;
      setData(responseData?.data || []);
    } catch (error) {
      toast.error(getApiErrorMessage(error, "Failed to load sub category"), {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light",
      });
      console.log(error);
    }
  };

  useEffect(() => {
    const id = location.pathname.split("/")[2];

    if (!isNaN(id)) {
      setId(id);
    }
    if (ID !== null) {
      fetchData();
    }
  }, [ID]);

  useEffect(() => {
    if (data !== null) {
      setImage(resolveMediaUrl(data.imageUrl));
      setBangla(data.bangla);
      setTamil(data.tamil);
      setMalayalam(data.malayalam);
      setOdia(data.odia);
      setName(data.name);
      setCategoryId(data.categoryId);
      setcatId(data.categoryId);
      setTelugu(data.telugu);
      setHindi(data.hindi);
      setGujarati(data.gujarati);
      setKannada(data.kannada);
      setMarathi(data.marathi);
      setPunjabi(data.punjabi);
    }
  }, [data]);

  const fetchCategory = async () => {
    try {
      const response = await getCategories();
      const responseData = response.data;
      setCategoryData(responseData?.data || []);
    } catch (error) {
      toast.error(getApiErrorMessage(error, "Failed to load categories"), {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light",
      });
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  useEffect(() => {
    if (!data || !categoryData.length) return;
    const defaultCategory = categoryData.find((i) => i.id === categoryId);
    setParent(defaultCategory || null);
  }, [categoryData, categoryId, data]);

  const handleUploadVideo = async () => {
    try {
      const missingRequiredText =
        !name ||
        !hindi ||
        !gujarati ||
        !marathi ||
        !kannada ||
        !odia ||
        !tamil ||
        !telgu ||
        !bangla ||
        !punjabi;

      if ((!ID && (missingRequiredText || !file)) || (ID && !name))
        return toast.error("Fill All Fields !", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          theme: "light",
        });

      setLoading(true);
      const formData = new FormData();
      formData.append("priority", 2);
      formData.append("categoryId", catId);
      formData.append("name", name);
      formData.append("hindi", hindi || "");
      formData.append("gujarati", gujarati || "");
      formData.append("marathi", marathi || "");
      formData.append("kannada", kannada || "");
      formData.append("odia", odia || "");
      formData.append("malayalam", malayalam || "");
      formData.append("tamil", tamil || "");
      formData.append("telugu", telgu || "");
      formData.append("bangla", bangla || "");
      formData.append("punjabi", punjabi || "");

      if (!ID) {
        if (!file) {
          setLoading(false);
          return toast.error(" Upload Image  !", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            theme: "light",
          });
        }
        formData.append("image", file);
        const response = await addSubCategory(formData);
        if (response) {
          setLoading(false);
          navigate(`/subCategory`, { replace: true, state: { results: true } });
        }
      } else {
        if (file instanceof File) {
          formData.append("image", file);
        }
        const response = await updateSubCategory(ID, formData);
        if (response) {
          setLoading(false);
          navigate(`/subCategory`, { replace: true, state: { update: true } });
        }
      }
    } catch (error) {
      setLoading(false);
      toast.error(getApiErrorMessage(error, "Error saving sub category"), {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light",
      });
      console.log(error);
    }
  };

  const changeHandler = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const allowedFormats = ["image/png", "image/webp", "image/jpeg"];
    if (allowedFormats.includes(file.type)) {
      setFile(file);
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setImage(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    } else {
      event.target.value = "";
      toast.error(
        "Image type should be image/png', 'image/webp', 'image/jpeg ",
        {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
        }
      );
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && ["image/png", "image/webp", "image/jpeg"].includes(droppedFile.type)) {
      setFile(droppedFile);
      const reader = new FileReader();
      reader.onload = (ev) => {
        setImage(ev.target.result);
      };
      reader.readAsDataURL(droppedFile);
    } else if (droppedFile) {
      toast.error("Image type should be PNG, WEBP, or JPEG", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
      });
    }
  };

  const handleCategory = (value) => {
    if (value) setcatId(value.id);
    else {
      setcatId("");
    }
  };

  return (
    <AdminPageLayout
      eyebrow="Content Structure"
      title={ID !== null ? "Edit Subcategory" : "Add Subcategory"}
      description="Manage sub category visuals, parent mapping, and language translations using the same premium form system."
      actions={
        <AdminAction
          variant="outline"
          startIcon={<ArrowBack fontSize="small" />}
          onClick={() => navigate("/subCategory")}
        >
          Back to listing
        </AdminAction>
      }
    >
      <AdminSectionCard title="Sub category details" description="Update the parent category, image, and translated names.">
        {ID !== null && data?.creator?.fullName && (
          <p className="mb-4 text-sm text-stone-600">
            <span className="font-medium text-stone-700">Created By:</span>{" "}
            {data.creator.fullName}
          </p>
        )}
        <div className="admin-form-body overflow-y-auto max-h-[70vh]">
          <div className="grid grid-cols-1 gap-6">
            {/* Large Drag & Drop Zone */}
            <div>
              <label className="block text-sm font-medium leading-6 text-stone-700 mb-3">
                SubCategory Image
              </label>
              <div
                className="min-h-[200px] border-2 border-dashed rounded-xl bg-stone-50 flex flex-col items-center justify-center cursor-pointer transition-colors hover:bg-stone-100 hover:border-stone-400"
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => document.getElementById("subcategory-image-input").click()}
              >
                <input
                  id="subcategory-image-input"
                  type="file"
                  accept="image/png, image/webp, image/jpeg"
                  onChange={changeHandler}
                  className="hidden"
                />
                {image ? (
                  <div className="w-full h-full flex items-center justify-center p-4">
                    <img
                      src={image}
                      alt="Preview"
                      className="max-h-[180px] object-contain rounded-lg"
                      onError={() => setImage("")}
                    />
                  </div>
                ) : (
                  <div className="text-center p-6">
                    <svg className="mx-auto h-12 w-12 text-stone-400 mb-3" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <p className="text-stone-700 font-medium">Click or drag file to this area to upload</p>
                    <p className="text-stone-400 text-sm mt-1">PNG, WEBP, JPEG (max 5MB)</p>
                  </div>
                )}
              </div>
            </div>

            {/* Category Selector - Full Width */}
            <div>
              <label className="block text-sm font-medium leading-6 text-stone-700 mb-2">
                Parent Category
              </label>
              {ID === null || categoryId === 1 ? (
                <Autocomplete
                  disablePortal
                  id="category"
                  options={categoryData}
                  defaultValue={{ id: 1, name: "Agriculture" }}
                  getOptionLabel={(option) => option?.name || ""}
                  onChange={(_event, newValue) => handleCategory(newValue)}
                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": { borderRadius: "0.5rem" },
                      }}
                    />
                  )}
                />
              ) : parent !== null ? (
                <Autocomplete
                  disablePortal
                  id="category"
                  options={categoryData}
                  defaultValue={parent ? { id: parent.id, name: parent.name } : null}
                  getOptionLabel={(option) => option?.name || ""}
                  onChange={(_event, newValue) => handleCategory(newValue)}
                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": { borderRadius: "0.5rem" },
                      }}
                    />
                  )}
                />
              ) : null}
            </div>

            {/* Form Fields Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium leading-6 text-stone-700 mb-2">
                  Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue={name}
                  placeholder="Enter subcategory name"
                  className="block w-full rounded-xl border-0 py-2.5 text-stone-900 shadow-sm ring-1 ring-inset ring-stone-300 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-stone-900 sm:text-sm sm:leading-6 transition-shadow px-4"
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div>
                <label className="block text-sm font-medium leading-6 text-stone-700 mb-2">
                  Hindi Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue={hindi}
                  placeholder="Hindi translation"
                  className="block w-full rounded-xl border-0 py-2.5 text-stone-900 shadow-sm ring-1 ring-inset ring-stone-300 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-stone-900 sm:text-sm sm:leading-6 transition-shadow px-4"
                  onChange={(e) => setHindi(e.target.value)}
                />
              </div>

              <div>
                <label className="block text-sm font-medium leading-6 text-stone-700 mb-2">
                  Gujarati Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue={gujarati}
                  placeholder="Gujarati translation"
                  className="block w-full rounded-xl border-0 py-2.5 text-stone-900 shadow-sm ring-1 ring-inset ring-stone-300 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-stone-900 sm:text-sm sm:leading-6 transition-shadow px-4"
                  onChange={(e) => setGujarati(e.target.value)}
                />
              </div>

              <div>
                <label className="block text-sm font-medium leading-6 text-stone-700 mb-2">
                  Marathi Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue={marathi}
                  placeholder="Marathi translation"
                  className="block w-full rounded-xl border-0 py-2.5 text-stone-900 shadow-sm ring-1 ring-inset ring-stone-300 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-stone-900 sm:text-sm sm:leading-6 transition-shadow px-4"
                  onChange={(e) => setMarathi(e.target.value)}
                />
              </div>

              <div>
                <label className="block text-sm font-medium leading-6 text-stone-700 mb-2">
                  Kannada Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue={kannada}
                  placeholder="Kannada translation"
                  className="block w-full rounded-xl border-0 py-2.5 text-stone-900 shadow-sm ring-1 ring-inset ring-stone-300 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-stone-900 sm:text-sm sm:leading-6 transition-shadow px-4"
                  onChange={(e) => setKannada(e.target.value)}
                />
              </div>

              <div>
                <label className="block text-sm font-medium leading-6 text-stone-700 mb-2">
                  Odia Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue={odia}
                  placeholder="Odia translation"
                  className="block w-full rounded-xl border-0 py-2.5 text-stone-900 shadow-sm ring-1 ring-inset ring-stone-300 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-stone-900 sm:text-sm sm:leading-6 transition-shadow px-4"
                  onChange={(e) => setOdia(e.target.value)}
                />
              </div>

              <div>
                <label className="block text-sm font-medium leading-6 text-stone-700 mb-2">
                  Malayalam Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue={malayalam}
                  placeholder="Malayalam translation"
                  className="block w-full rounded-xl border-0 py-2.5 text-stone-900 shadow-sm ring-1 ring-inset ring-stone-300 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-stone-900 sm:text-sm sm:leading-6 transition-shadow px-4"
                  onChange={(e) => setMalayalam(e.target.value)}
                />
              </div>

              <div>
                <label className="block text-sm font-medium leading-6 text-stone-700 mb-2">
                  Tamil Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue={tamil}
                  placeholder="Tamil translation"
                  className="block w-full rounded-xl border-0 py-2.5 text-stone-900 shadow-sm ring-1 ring-inset ring-stone-300 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-stone-900 sm:text-sm sm:leading-6 transition-shadow px-4"
                  onChange={(e) => setTamil(e.target.value)}
                />
              </div>

              <div>
                <label className="block text-sm font-medium leading-6 text-stone-700 mb-2">
                  Telugu Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue={telgu}
                  placeholder="Telugu translation"
                  className="block w-full rounded-xl border-0 py-2.5 text-stone-900 shadow-sm ring-1 ring-inset ring-stone-300 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-stone-900 sm:text-sm sm:leading-6 transition-shadow px-4"
                  onChange={(e) => setTelugu(e.target.value)}
                />
              </div>

              <div>
                <label className="block text-sm font-medium leading-6 text-stone-700 mb-2">
                  Bangla Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue={bangla}
                  placeholder="Bangla translation"
                  className="block w-full rounded-xl border-0 py-2.5 text-stone-900 shadow-sm ring-1 ring-inset ring-stone-300 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-stone-900 sm:text-sm sm:leading-6 transition-shadow px-4"
                  onChange={(e) => setBangla(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium leading-6 text-stone-700 mb-2">
                  Punjabi Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue={punjabi}
                  placeholder="Punjabi translation"
                  className="block w-full rounded-xl border-0 py-2.5 text-stone-900 shadow-sm ring-1 ring-inset ring-stone-300 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-stone-900 sm:text-sm sm:leading-6 transition-shadow px-4"
                  onChange={(e) => setPunjabi(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        <AdminFormFooter>
          <AdminAction onClick={handleUploadVideo} loading={loading}>
            {ID !== null ? "Update SubCategory" : "Add SubCategory"}
          </AdminAction>
        </AdminFormFooter>
      </AdminSectionCard>
    </AdminPageLayout>
  );
}
